module.exports = __webpack_public_path__ + "media/images/icon__edit--rb-red@2x-7544bcd12a639dcaf0ac9a800c53c35d.png";